import { graphql } from '@api/generated';

import { getClient } from '../../../api/client';
import { ConversationsQuery } from '@api/generated/graphql';
import FullStoryModule from '@modules/FullStoryModule';

const GET_PCS_CONVERSATION_TIMEOUT_IN_MS = 10_000;

const GET_CONVERSATIONS_QUERY = graphql(`
  query conversations($input: ConversationsInput!) {
    conversations(input: $input) {
      id
      sid
      queueIds
      tenantId
      traits
      agentIds
    }
  }
`);

export type PcsConversationType = ConversationsQuery['conversations'][0];

// we should retry this until we get a PCS conversation for the call.
async function getPcsConversation(
  kazooCallId: string,
): Promise<PcsConversationType | undefined> {
  let conversation: PcsConversationType | undefined = undefined;
  const startTime = Date.now();
  const fetchConversation = async (): Promise<
    PcsConversationType | undefined
  > => {
    const { data, error } = await getClient().query({
      query: GET_CONVERSATIONS_QUERY,
      variables: {
        input: {
          kazooId: kazooCallId,
        },
      },
      fetchPolicy: 'network-only',
    });

    if (error) {
      throw new Error(error.message);
    }

    if (data?.conversations && data.conversations.length > 0) {
      return data.conversations[0];
    }

    if (Date.now() - startTime < GET_PCS_CONVERSATION_TIMEOUT_IN_MS) {
      return new Promise((resolve) => {
        setTimeout(async () => {
          resolve(await fetchConversation());
        }, 1000); // Retry after 1 second
      });
    }

    return undefined;
  };

  conversation = await fetchConversation();

  if (conversation) {
    FullStoryModule.trackEvent('[CCP-Call] Conversation Identified', {
      conversationSid: conversation.sid,
      remoteCallId: kazooCallId,
    });
  }

  return conversation;
}

export default getPcsConversation;
